import {
  Activity,
  ActivityFeedItemDefinition,
} from "@ofqual/portal-activity-feed";
import {
  ActivityType,
  ChangeActivityBody,
} from "./SubmissionActivityFeedTypes";
import { SvrSubmission } from "../../../services/domain/SvrSubmission";
import { fieldLabels } from "../fieldLabels";

export const buildDefinitions = (
  submission: SvrSubmission | null,
  onClick: (entity: Activity | null) => void
) => {
  if (!submission) {
    return [];
  }

  const submissionCreated: ActivityFeedItemDefinition<{ summary: string }> = {
    activityType: ActivityType.SvrSubmissionCreated,
    Body: ({ body }) => <>{body.summary}</>,
    options: [],
  };

  const submissionDeactivated: ActivityFeedItemDefinition<{
    summary: string;
  }> = {
    activityType: ActivityType.SvrSubmissionDeactivated,
    Body: ({ body }) => <>{body.summary}</>,
    options: [],
  };

  const submissionUpdated: ActivityFeedItemDefinition<ChangeActivityBody> = {
    activityType: ActivityType.SvrSubmissionUpdated,
    Body: ({ body }) => (
      <>
        <b>Updated:</b>{" "}
        {body.changes.map((item) => `"${fieldLabels[item.field]}"`).join(",")}
      </>
    ),
    options: [
      {
        label: "Show Changes",
        onClick,
      },
    ],
  };

  return [submissionCreated, submissionUpdated, submissionDeactivated];
};
